
import { useState, useEffect } from "react";
//-----------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    weeknum,
    myAxios, MyFormData, MyDate,
    Select, changeWeek
} from "src/components/common/functions";
//-----------------------------------------------------------------------------------------
export default function TransferSelect({
    closeIt, 
    project, 
    projectId, 

    setShowTransferSelect, 
    setSelectedUsers, 
    history, 
    
    currentWorkInstruction, 
    setCurrentWorkInstruction, 

    setCurrentWorkInstructionRenderSwitch, 
    setWorkInstructionRenderSwitch
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    //-----------------------------------------------------------------------------------------
    const [targetProjects, setTargetProjects] = useState([]);
    const [targetProject, setTargetProject] = useState({});
    //-----------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            //-----------------------------------------------------------
            setShowLoader(true);
            const resTargetProjects = await myAxios("workInstructions/readTargetProjects.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resTargetProjects) return;
            //-----------------------------------------------------------
            setTargetProjects(resTargetProjects.data);
        }
        getData();
        return () => {isMounted = false;}
    }, [])
    //-----------------------------------------------------------------------------------------
    return (
        <Modal
            closeIt = {closeIt}
            title = "Transfer This Work Instruction To Which Project"
            width = {"60%"}
            actionKey = "Transfer"
            handleFormSubmit = {async e => {
                e.preventDefault();
                const formData = new MyFormData(e.currentTarget);
                if(!targetProject.projectHashKey){
                    window.alert("No project selected.")
                    return;
                }
                const jobWeek = weeknum(currentWorkInstruction.startTime.substring(0, 10));
                const today = new MyDate();
                const late = ((weeknum(today)) > changeWeek(jobWeek, 1)) || (
                    (weeknum(today)) > jobWeek && 
                    (
                        ((today.getDay() === 2) && today.getHours() >= 12)
                        || (today.getDay() > 2 || today.getDay() === 0)
                    )
                ); // by Tuesday noon
                if(late){
                    if(!window.confirm("Start Date is too old. We will send an email to the payroll.")) return;
                }
                //-----------------------------------------------------
                formData.append("targetProjectHashKey", targetProject.projectHashKey);
                formData.append("workInstructionHashKey", currentWorkInstruction.workInstructionHashKey);
                // formData.append("targetProjectFolderId", targetProject.projectFolderId);
                // formData.append("projectFolderId", project.projectFolderId);
                // formData.append("workInstructionFolderId", currentWorkInstruction.folderId);
                //-----------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("workInstructions/transfer.php", formData);
                setShowLoader(false);
                if(!res) return;
                //-----------------------------------------------------------
                const formData1 = new MyFormData();
                formData1.append("workInstructionHashKey", currentWorkInstruction.workInstructionHashKey);
                //-----------------------------------------------------------
                setShowLoader(true);
                const preRes = await myAxios("workInstructions/handlePDF.php", formData1);
                setShowLoader(false);
                if(!preRes) return;
                //-----------------------------------------------------------
                const preData = preRes.data;
                for(let p of preData){
                    let formData2;
                    formData2 = new MyFormData();
                    for(let [key, value] of Object.entries(p)){
                        if(key === "travelStartTime" || key === "workStartTime" || key === "workEndTime" || key === "travelEndTime"){
                            formData2.set(key, value.substring(11, 16));
                            formData2.set(key.replace("Time", "Date"), value.substring(0, 10));
                        }else{
                            formData2.set(key, value);
                        }
                    }
                    formData2.set("action", "Submit");
                    formData2.set("form", "jobTag");
                    formData2.set("sketches", "[]");
                    formData2.set("submitDate", p.jobTagSubmitTime.substring(0, 10));
                    const temp = document.createElement("div");
                    temp.innerHTML = p.workInstructionDescription;
                    formData2.append("workRequestedText", temp.innerText);
                    temp.innerHTML = p.workPerformed;
                    formData2.append("workPerformedText", temp.innerText);
                    temp.innerHTML = p.additionalInfo;
                    formData2.append("additionalInfoText", temp.innerText);
                    const pD = JSON.parse(p.sign); 
                    const canvas = document.createElement("canvas");
                    canvas.width = 900;
                    canvas.height = 300;
                    const context = canvas.getContext("2d");
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    pD.forEach(currentPicData => {
                        context.beginPath();
                        switch(currentPicData.drawMode){
                            case "pen":
                                context.moveTo(currentPicData.data[0].x , currentPicData.data[0].y);
                                currentPicData.data.forEach(step => {
                                    context.lineTo(step.x, step.y);
                                })
                                context.stroke();
                            break;
                            default:
                        }
                    })
                    context.beginPath();
                    formData2.set("signUrl", canvas.toDataURL());
                    //-----------------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("workLogs/jT.php", formData2);
                    setShowLoader(false);
                    if(!res) return;
                    //-----------------------------------------------------------
                }
                setShowTransferSelect(false);
                setWorkInstructionRenderSwitch(workInstructionRenderSwitch => !workInstructionRenderSwitch);
                setCurrentWorkInstructionRenderSwitch(currentWorkInstructionRenderSwitch => !currentWorkInstructionRenderSwitch);
                setSelectedUsers([]);
                setCurrentWorkInstruction(null);
                history.replace(`/Projects/${projectId}`);
            }}
        >
            <Select className = "m-3"
                options = {targetProjects.filter(p => p.projectHashKey !== project.projectHashKey).map(p => ({...p, value:p.projectHashKey, label:p.projectName}))} 
                onChange = {e => {setTargetProject(e)}}
            />
            <input name = "targetProject" value = {JSON.stringify(targetProject)} readOnly className = "nodisplay"/>
        </Modal>
    )
}